import React from "react";

import { Vibration, View } from "react-native";
import { Bubble, IMessage, BubbleProps } from "react-native-gifted-chat";
// import ChatCustomView from "./ChatCustomView";
import ChantText from "./ChantText";
import ChatImage from "./ChatImage";
// import ChatAudio from "./ChatAudio";
import ChatTicks from "./ChatTicks";
import ChatTime from "./ChatTime";

import { colors } from "assets/constants";
import { Button } from "components";

interface ChatBubbleT extends BubbleProps<IMessage> {
  onReply?: (msg: IMessage) => void;
}

export default function ChatBubble(props: ChatBubbleT) {
  const { currentMessage, onReply } = props;

  return (
    <View>
      <Bubble
        renderTicks={() => <ChatTicks received={currentMessage?.received} />}
        {...(props as BubbleProps<IMessage>)}
        wrapperStyle={{
          right: {
            backgroundColor: colors.white,
            marginLeft: 60,
            marginBottom: 5,
            overflow: "hidden",
          },
        }}
        // renderCustomView={(params) =>
        //   currentMessage?.file?.uri && <ChatCustomView {...params} />
        // }
        // renderMessageAudio={(params) => <ChatAudio {...params} />}
        renderMessageText={(params) => <ChantText {...params} />}
        renderMessageImage={(params) => <ChatImage {...params} />}
        renderTime={(params) => <ChatTime {...params} />}
      />
      {/* <Button
        style={{ transform: [{ scaleX: -1 }] }}
        absolute
        bottom={10}
        left={25}
        icon={{ type: "fontIsTo", name: "reply" }}
        circle={25}
        bgColor={colors.theme}
        onPress={() => {
          Vibration.vibrate(100);
          currentMessage && onReply && onReply(currentMessage);
        }}
      /> */}
    </View>
  );
}
